import React from 'react';
import { IonText } from '@ionic/react';
import FormulaCard from './FormulaCard';

interface IProps {
    formulas: any[];
}

const Formulas: React.FC<IProps> = (props) => {
    return (
        <>
            {Array.isArray(props.formulas) && props.formulas.map((Formula, index) => <FormulaCard formula={Formula} key={index} />)}
            {(!Array.isArray(props.formulas) || props.formulas.length === 0) && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 24px', gap: '8px' }}>
                    <IonText color="medium" style={{ fontSize: '14px' }}>No formulas found</IonText>
                    <IonText color="medium" style={{ fontSize: '13px' }}>Pull to refresh</IonText>
                </div>
            )}
        </>
    );
};

export default Formulas;
